module.exports = __webpack_public_path__ + "static/images/8f7b67efc2b6bd962b494f8541578b02.png";